<template>
  <div class="notification-bar">
    <NotificationBarItem
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      @onClose="remove(notification)" />
  </div>
</template>

<script>
import NotificationBarItem from '@/components/_shared/notification-bar/NotificationBarItem.vue'

let nextId = 1

export default {
  name: 'NotificationBar',
  data () {
    return {
      notifications: []
    }
  },
  components: {
    NotificationBarItem
  },
  methods: {
    add (notification) {
      this.remove(nextId)
      this.notifications.push({ ...notification, id: nextId++ })
      setTimeout(() => {
        window.addEventListener('click', this.validateClickOutside)
      }, notification.delay)
    },
    success (message, delay = 3000, allowHTML = false) {
      this.add({ type: 'success', iconName: 'check-circle', message, delay, allowHTML })
    },
    warning (message, delay = 3000, allowHTML = false) {
      this.add({ type: 'warning', iconName: 'exclamation-triangle', message, delay, allowHTML })
    },
    error (message, delay = 12000, allowHTML = false) {
      this.add({ type: 'danger', iconName: 'times', message, delay, allowHTML })
    },
    remove (notificationToRemove, allowHTML = false) {
      this.notifications = this.notifications.filter(
        notification => notification.id !== notificationToRemove.id
      )
      window.removeEventListener('click', this.validateClickOutside)
    },
    validateClickOutside (event) {
      if (!event.target.closest('.alert')) this.remove(this.notifications[0])
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-bar {
  position: fixed;
  top: 0;
  left: calc(50% - 200px);
  width: 400px;
  margin-top: 7px;
  z-index: 1020;
}
</style>
